import '@fortawesome/fontawesome-free/css/all.min.css'

// Import from module VUE the class VUE
import Vue from 'vue'
import App from './App.vue'

import Multiselect from 'vue-multiselect';

Vue.config.productionTip = false

// Import others javascript 
import router from './router/index'

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// Install BootstrapVue
Vue.use(BootstrapVue)

// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

// Register globally
Vue.component('multiselect', Multiselect);

// Import css stylesheet 
import './assets/css/main.css';

// Init with VUE it's instance
new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
